<template>
  <div class="column is-10">
    <table class="table">
      <tr>
        <td>Name</td>
        <td v-text="name"></td>
      </tr>
      <tr>
        <td>Email</td>
        <td v-text="email"></td>
      </tr>
      <tr>
        <td>Phone</td>
        <td v-text="phone"></td>
      </tr>
      <tr>
        <td>Birth Place</td>
        <td v-text="birth_place"></td>
      </tr>
      <tr>
        <td>Birthday</td>
        <td v-text="birthday"></td>
      </tr>
      <tr>
        <td>DATE</td>
        <td v-text="date_group"></td>
      </tr>
      <tr>
        <td>My Small Group Leader Role</td>
        <td v-text="date_group_leader_role"></td>
      </tr>
      <tr>
        <td>My Small Group Leader Name</td>
        <td v-text="date_group_leader_name"></td>
      </tr>
      <tr>
        <td>My Small Group Leader Phone</td>
        <td v-text="date_group_leader_phone"></td>
      </tr>
      <tr>
        <td>My Small Group Leader Email</td>
        <td v-text="date_group_leader_email"></td>
      </tr>
      <tr>
        <td>My Previous Ministry</td>
        <td v-text="previous_ministry"></td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  data () {
    return {
      name: '',
      email: '',
      phone: '',
      birth_place: '',
      birthday: '',
      date_group: '',
      date_group_leader_role: '',
      date_group_leader_name: '',
      date_group_leader_phone: '',
      date_group_leader_email: '',
      previous_ministry: ''
    }
  },
  props: [
    'profileData'
  ],
  created () {
    var self = this
    this.name = this.profileData.name
    this.email = this.profileData.email
    this.phone = this.profileData.phone
    this.birth_place = this.profileData.birth_place
    this.birthday = this.profileData.birthday
    this.date_group = this.profileData.date_group
    this.getDateGroupLeaderRoleDetail(this.profileData.date_group_leader_role, function (resultValue) {
      self.date_group_leader_role = resultValue
    })
    this.date_group_leader_name = this.profileData.date_group_leader_name
    this.date_group_leader_phone = this.profileData.date_group_leader_phone
    this.date_group_leader_email = this.profileData.date_group_leader_email
    this.getPreviousMinistryDetail(this.profileData.previous_ministry, function (resultValue) {
      self.previous_ministry = resultValue
    })
  },
  watch: {
    profileData (value) {
      var self = this
      this.name = value.name
      this.email = value.email
      this.phone = value.phone
      this.birth_place = value.birth_place
      this.birthday = value.birthday
      this.date_group = value.date_group
      if (typeof value.date_group_leader_role !== 'undefined' && value.date_group_leader_role !== '') {
        this.getDateGroupLeaderRoleDetail(value.date_group_leader_role, function (resultValue) {
          self.date_group_leader_role = resultValue
        })
      }
      this.date_group_leader_name = value.date_group_leader_name
      this.date_group_leader_phone = value.date_group_leader_phone
      this.date_group_leader_email = value.date_group_leader_email
      if (typeof value.previous_ministry !== 'undefined' && value.previous_ministry !== '') {
        this.getPreviousMinistryDetail(value.previous_ministry, function (resultValue) {
          self.previous_ministry = resultValue
        })
      }
    }
  },
  methods: {
    getDateGroupLeaderRoleDetail (id, callback) {
      var self = this
      self.flyPost('member/get_date_leader_group_role_detail', {
        id: id
      }).then(function (response) {
        if (response.data.response_code === 1) {
          callback(response.data.data)
        } else {
          /*
          var result = response.data.message
          for (var name in response.data.message) {
            self.errors.remove(name)
            self.errors.add(name, result[name])
          }
          */
        }
      }).catch(function (response) {
        self.errorMessage(response)
      })
    },
    getPreviousMinistryDetail (id, callback) {
      var self = this
      self.flyPost('member/get_previous_ministry_detail', {
        id: id
      }).then(function (response) {
        if (response.data.response_code === 1) {
          callback(response.data.data)
        } else {
          /*
          var result = response.data.message
          for (var name in response.data.message) {
            self.errors.remove(name)
            self.errors.add(name, result[name])
          }
          */
        }
      }).catch(function (response) {
        self.errorMessage(response)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/profile/components/ProfilePage.vue